

import { defineComponent } from 'vue';
import {
    NForm,
    NFormItem,
    NInput,
    NButton,
} from 'naive-ui'
import { mapState } from 'pinia';

import { useAuthStore } from '../store/auth.store';
import ComponentBase from '../components/component-base';


export default defineComponent({

    extends: ComponentBase,

    components: {
        NForm,
        NFormItem,
        NInput,
        NButton,
    },

    data() {
        return {
            avoltaConnectLogo: require('@/avolta-connect-logo.png').default,
            valid: false,
            form: {
                company: '',
                message: '',
                email: ''
            },
            rules: {
                email: {
                    required: true,
                },
                company: {
                    required: true,
                }
            }
        }
    },

    computed: {
        ...mapState(useAuthStore, ['user'])
    },

    mounted() {
        this.form.email = this.user.email;
    },
    
    methods: {
        submit(e: Event): void {

            e.preventDefault();

            if(!this.valid) {
                return;
            }

            this.failed = false;
            this.isLoading = true;

            const { company, email, message } = this.form;
            const subject: string = encodeURI('Avolta Connect Dashboard - Request for Avolta group');
            const body = encodeURI(`
User ${this.user.username} from company ${company} request access to an avolta group
"${message}"

Contact user at ${email}
            `);

            
            window.location.href = `mailto:support@elichens.com?subject=${subject}&body=${body}`;
        }
    },

    watch: {
        form: {
            handler() {
                //@ts-ignore
                this.$refs?.form?.validate((errors) => {
                    this.valid = !errors;
                })
                .catch((err: Error) => {
                    this.er
                    if (err) {
                        this.valid = false;
                    }
                });
            },
            deep: true,
        }
    }

});
